import { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../contexts/ThemeProvider";
import { motion } from "framer-motion";
import { LanguageContext } from "../contexts/LanguageProvider";
export default function Footer() {
  const { colorsObj } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="w-full"
      style={{
        backgroundColor: colorsObj.colorBackground,
        backgroundImage: `repeating-radial-gradient(circle at 0 0, transparent 0, ${colorsObj.colorBackground} 16px),
                         repeating-linear-gradient(${colorsObj.colorOverlay}, ${colorsObj.colorBackground})`,
        color: colorsObj.colorText,
      }}
    >
      <div className="px-8 md:px-24 lg:px-44 2xl:px-64 py-12 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-3">
          <img src="/logo-omnia.png" alt="Omnia360 Logo" className="w-10" />
          <span className="font-semibold text-lg">Omnia360</span>
        </div>

        <div className="text-sm flex gap-6 items-center">
          <Link
            to="/privacy-policy"
            className="hover:underline hover:text-yellow-500 transition-colors"
          >
            {t("footer-pp")}
          </Link>
        </div>
      </div>

      <div className="text-center text-xs pb-6 text-gray-500 dark:text-gray-400">
        © {new Date().getFullYear()} {t("footer-rights")}
      </div>
    </motion.footer>
  );
}
